import { CreateDialog, EditDialog } from "@react-admin/ra-form-layout";
import React from "react";
import {
    Datagrid,
    DateField,
    DateInput,
    EditButton,
    List,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput,
    Toolbar,
} from "react-admin";

const filters = [
    <TextInput key="domain" label="Domain" source="domain@~~" />,
    <DateInput label="From" key="after" source="after" alwaysOn />,
    <DateInput label="To" key="before" source="before" alwaysOn />,
];

export const DomainsList = () => (
    <>
        <List sort={{ field: "created_at", order: "DESC" }} filters={filters} hasCreate>
            <Datagrid bulkActionButtons={false}>
                <TextField source="domain" />
                <DateField source="created_at" showTime />
                <DateField source="disabled_at" showTime />
                <TextField source="disable_reason" />
                <EditButton />
            </Datagrid>
        </List>
        <CreateDialog>
            <SimpleForm>
                <TextInput source="domain" validate={required()} />
            </SimpleForm>
        </CreateDialog>
        <EditDialog>
            <SimpleForm
                toolbar={
                    <Toolbar>
                        <SaveButton />
                    </Toolbar>
                }
            >
                <TextInput source="domain" validate={required()} />
                <SelectInput
                    source="status"
                    validate={required()}
                    choices={[
                        { id: "enabled", name: "Enabled" },
                        { id: "disabled", name: "Disabled" },
                    ]}
                />
                <TextInput source="reason" />
            </SimpleForm>
        </EditDialog>
    </>
);
